export default __webpack_public_path__ + "static/media/4-2_image18@2x.a6b099c7.png";